import { Flex, Heading, Image, Text, VStack } from "@chakra-ui/react";
import React from "react";

const About = () => {
  return (
    <VStack
      spacing="5"
      maxW={"1000px"}
      m="auto"
      height={{ base: "100%", md: "90vh" }}
      justifyContent="center"
      alignItems="center"
      p="8"
      id="about"
    >
      <Heading>About me</Heading>
      <Flex flexDir={{ base: "column", md: "row" }} justifyContent={"center"} alignItems={"center"}>
        <Image
          w={{ base: "50%", md: "40%" }}
          src="https://messengerbot.app/wp-content/uploads/2021/08/User-Interface-USER-INTERFACE-OF-MOBILE-APPS.png"
        />
        <Text fontSize={"20px"}>
        I am a Mechanical Engineering graduate and my enthusiasm towards the IT industry, made me a Full-Stack Web Development by profession with a specialization in MERN Stack, JavaScript, HTML, and CSS.
            <br/>
I am keen and enthusiastic to apply what I have learned to build products and services that will help people. I am adaptable and a team player and I would like to continually challenge myself, build my skills, and contribute to the growth of the organization.
        </Text>
      </Flex>
    </VStack>
  );
};

export default About;
